import axios from 'axios'

import store from '@/store'

import { mapActions, mapGetters, mapState } from 'vuex'
import router from '../router'
// import { Spin } from 'iview'
const addErrorLog = errorInfo => {
  const {
    statusText,
    status,
    request: {
      responseURL
    }
  } = errorInfo
  let info = {
    type: 'ajax',
    code: status,
    mes: statusText,
    url: responseURL
  }
  if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
}

class HttpRequest {
  constructor (baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        //
      }
    }
    return config
  }
  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      // console.info(Object.keys(store.state.user.userId).length==0)
      // if(Object.keys(store.state.user.userId).length!=0){
      //     config.headers.userId = store.state.user.userId
      // }
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const {
        data,
        status
      } = res
      return {
        data,
        status
      }
    }, error => {
      this.destroy(url)
      if (error && error.response) {
        switch (error.response.status) {
          case 400:
            // error.message = '错误请求'
            // alert('错误请求')
            router.currentRoute.path !== '/error' &&
                    router.replace({
                      path: '/error',
                      query: { code: '400' }
                    })
            break
          case 401:
            // error.message = '未授权，请重新登录'// 跳回登录
            // alert('未授权，请重新登录')
            router.currentRoute.path !== '/error' &&
                    router.replace({
                      path: '/error',
                      query: { code: '401' }
                    })
            break
          case 403:
            // error.message = '拒绝访问' // 跳回登录
            // alert('拒绝访问')
            router.currentRoute.path !== '/error' &&
                    router.replace({
                      path: '/error',
                      query: { code: '403' }
                    })
            break
            // case 404:
            //     alert('请求错误,未找到该资源')
            //     router.replace({
            //         path: '/error',
            //         query: { code: '404' }
            //     })
            //     break
          case 405:
            router.replace({
              path: '/error',
              query: { code: '405' }
            })
            break
          case 408:
            // err.message = '请求超时'
            break
          case 500:
            // err.message = err.response.data.message
            break
          case 501:
            // err.message = '网络未实现'
            break
          case 502:
            // err.message = '网络错误'
            break
          case 503:
            // err.message = '服务不可用'
            break
          case 504:
            // err.message = '网络超时'
            break
          case 505:
            // err.message = 'http版本不支持该请求'
            break
          default:
            // alert(`连接错误${error.response.status}`)
        }
      } else {
        console.log(error)
        error.message = '连接到服务器失败'
      }
      let errorInfo = error.response
      if (!errorInfo) {
        const {
          request: {
            statusText,
            status
          },
          config
        } = JSON.parse(JSON.stringify(error))
        errorInfo = {
          statusText,
          status,
          request: {
            responseURL: config.url
          }
        }
      }
      addErrorLog(errorInfo)
      return Promise.reject(error)
    })
  }
  request (options) {
    const instance = axios.create()
    let reqConfig = this.getInsideConfig()
    // let pc_Authorization = localStorage.getItem('pc_Authorization') || store.state.user.access
    let pc_Authorization = localStorage.getItem('pc_Authorization')
    reqConfig.headers['Authorization'] = `Bearer ${pc_Authorization}`
    options = Object.assign(reqConfig, options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
